module.exports = {
      id: "dc2ef42fe48fa910d6eb1b4f89c912e4bathroomEquipment-sink.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#dc2ef42fe48fa910d6eb1b4f89c912e4bathroomEquipment-sink.svg",
      toString: function () {
        return this.url;
      }
    }